import { get, post } from "@/Utils/axios";

export function requestGetDashboardBasicData(): any {
  return get(`Dashboard/GetDashboardBasicData`);
}

export function requestLoadWidgetGroup(widgetgroupno: string, model: any) {
  return post(`Dashboard/LoadWidgetGroup`, { widgetgroupno, model });
}

export function requestLoadWidgetCriteria(widgetgroupno: string) {
  return post(`Dashboard/LoadWidgetCriteria`, { widgetgroupno });
}

export function requestSaveUserLayout(widgetgroupno: string, layout: JSON, insightarea: string): any {
  return post(`Dashboard/SaveUserLayout`, { widgetgroupno, layout, insightarea });
}